// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6632":"ca23764f","9380":"65039541"}[chunkId] + ".chunk.css";
};